import { PX_PER_M } from "../config/constants";
import type { ObstacleConfig, Severity, SurfaceConfig } from "../config/types";

export const LOG_LIP_ANGLE = 35;

export type HitResult =
    | { kind: "clear" }
    | { kind: "hop"; speed: number }
    | { kind: "crash"; severity: Severity; speedLoss: number };

export function impactSeverity(speed: number, obstacle: Pick<ObstacleConfig, "crashAtSpeed">): Severity {
    const bands = obstacle.crashAtSpeed;
    if (!bands || speed < bands.medium) return "small";
    return speed < bands.large ? "medium" : "large";
}

export function clearsObstacle(airHeightM: number, obstacle: Pick<ObstacleConfig, "heightPx">): boolean {
    return airHeightM * PX_PER_M > (obstacle.heightPx ?? 0);
}

export function hitsLogSquareOn(headingDeg: number): boolean {
    return Math.abs(headingDeg) <= LOG_LIP_ANGLE;
}

export function resolveHit(key: string, obstacle: ObstacleConfig, speed: number, headingDeg: number, airHeightM: number): HitResult {
    if (obstacle.kind === "soft") return { kind: "hop", speed: obstacle.hopSpeed ?? 0 };
    if (clearsObstacle(airHeightM, obstacle)) return { kind: "clear" };
    if (key === "log" && hitsLogSquareOn(headingDeg)) return { kind: "hop", speed: obstacle.hopSpeed ?? 0 };
    return { kind: "crash", severity: impactSeverity(speed, obstacle), speedLoss: obstacle.speedLoss ?? 0 };
}

export function withGripBonus(surface: SurfaceConfig, bonus: number): SurfaceConfig {
    if (bonus === 1) return surface;
    return { ...surface, grip: surface.grip * bonus, turnLoss: 0 };
}
